export const EVENT_GET = 'EVENT::GET'
export const EVENT_LOADING = 'EVENT::LOADING'
export const EVENT_STREAMS = 'EVENT::STREAMS'
export const EVENT_REMOVE_STREAM_LOCAL = 'EVENT::UPDATE_LIVE_NOW'
export const EVENT_UPDATE = 'EVENT::UPDATE'
export const EVENT_GET_STATS = 'EVENT::STATS::GET'
export const EVENT_SET_DONATIONS = 'EVENT::DONATIONS::SET'
export const EVENT_DONATIONS_PUSH = 'EVENT::DONATIONS::PUSH'
export const EVENT_DONATIONS_REMOVE = 'EVENT::DONATIONS::REMOVE'
export const EVENTS_DONATIONS_SET_ID = 'EVENT::DONATIONS::SET_ID'
export const EVENT_SET_CHATS = 'EVENT::CHATS::SET'
export const EVENT_SET_CHAT_LOADING = 'EVENT::CHATS::SET_LOADING'
export const EVENT_REMOVE_MESSAGE = 'EVENT::CHATS::REMOVE'
export const EVENT_PUSH_CHATS = 'EVENT::CHATS::PUSH'
export const EVENT_TICKETS_SET = 'EVENT::TICKETS::SET'
export const EVENT_TICKETS_LOADING = 'EVENT::TICKETS::LOADING'
export const MY_TICKETS_LOADING = 'EVENT::MY_TICKETS::LOADING'
export const MY_TICKETS_SET = 'EVENT::MY_TICKETS::SET'
export const DONATIONS_LOADING = 'EVENT:DONATIONS::LOADING'



// WEBPACK FOOTER //
// ./src/types/actions/event.js